import { ChangeEvent, SetStateAction, useCallback, useEffect, useState } from 'react'
import { PointItemInterface } from '../../../../../../types/interfaces'

export const usePointItem = (
  setData: React.Dispatch<SetStateAction<PointItemInterface[]>>,
  data: PointItemInterface[],
  el: PointItemInterface,
  index: number,
) => {
  const [autocomplete] = useState<{ value: google.maps.places.Autocomplete | {} }>({ value: {} })

  const onPlaceChanged = useCallback(
    (e: Event) => {
      var place =
        autocomplete.value instanceof google.maps.places.Autocomplete &&
        autocomplete.value.getPlace()
      if (place && place.geometry && place.name && place.geometry.location) {
        let tempData = [...data]
        tempData[index].city.value = place.name
        tempData[index].city.latitude = place.geometry.location.lat()
        tempData[index].city.longitude = place.geometry.location.lng()
        tempData[index].city.isDirty = true
        setData(tempData)
      }
    },
    [data, index, autocomplete.value, setData],
  )

  const initAutocomplete = useCallback(
    (id: string) => {
      const htmlEl: HTMLInputElement | HTMLElement | null = document.getElementById(id)
      if (htmlEl && htmlEl instanceof HTMLInputElement)
        autocomplete.value = new google.maps.places.Autocomplete(htmlEl, {
          types: ['locality', 'administrative_area_level_3'],
          componentRestrictions: { country: [`RU`] },
          fields: ['geometry', 'name'],
        })

      if (autocomplete.value instanceof google.maps.places.Autocomplete)
        autocomplete.value.addListener('place_changed', onPlaceChanged)
    },
    [autocomplete, onPlaceChanged],
  )

  useEffect(() => {
    const regex = new RegExp('[0-9]')
    if (
      el.city.value.length > 2 &&
      // regex.test(el.city.value) &&
      Object.keys(autocomplete.value).length === 0
    ) {     
      initAutocomplete(`${el.id}`)
      const htmlEl: HTMLInputElement | null = document.querySelector(`${el.id}`)
      htmlEl && htmlEl.blur()
      setTimeout(() => {
        htmlEl && htmlEl.focus()
      }, 100)
    }

    return () => {
      const htmlEl: HTMLElement | null = document.getElementById(String(el.id))
      if (htmlEl) htmlEl.removeEventListener('place_changed', onPlaceChanged)
    }
  }, [el.city.value, el.id, autocomplete.value, initAutocomplete])

  const dataReset = (e: ChangeEvent<HTMLInputElement>) => {
    let tempData = [...data]
    tempData[index].city.value = e.target.value
    tempData[index].city.latitude = undefined
    tempData[index].city.longitude = undefined
    tempData[index].city.isDirty = true
    setData(tempData)
  }

  useEffect(() => {
    autocomplete.value = {}
  }, [data[index].sequence])

  return {
    dataReset,
  }
}
